import { UserContactInfo } from './api/contactInfo';
import { ApiDiscord } from './api/discord';

export const Api = {
  userContactInfo: UserContactInfo,
  discord: ApiDiscord
};
